export class OnboardingListSummaryDto {
  pendingHires: number;
  pendingReviewDocuments: number;
  rejectedDocuments: number;
}
